import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Experience`}</h2>
    <ProjectCard title="Electrical Switchgear & It's Applications" link="" bg="linear-gradient(to right, blue 0%, magenta 100%)" mdxType="ProjectCard">
    Training : #1 by Dbsons
    </ProjectCard>
    <ProjectCard title="Electric Motors" link="" bg="linear-gradient(to right, green 0%, yellow 100%)" mdxType="ProjectCard">
    Training : #2 by National Skill Training Institute (under GOI)
    </ProjectCard>
    <ProjectCard title="Electric Field Analysis on Extra High Voltage (EHV)" link="" bg="linear-gradient(to right, magenta 50%, cyan 100%)" mdxType="ProjectCard">
    Training : #3
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      